import { render } from "./MaterialTable.vue?vue&type=template&id=12aabb72&scoped=true"
import script from "./MaterialTable.vue?vue&type=script&lang=js"
export * from "./MaterialTable.vue?vue&type=script&lang=js"

import "./MaterialTable.vue?vue&type=style&index=0&id=12aabb72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12aabb72"]])

export default __exports__